module.exports = __webpack_public_path__ + "static/img/34.b4c0eba4.gif";